/* ============================================================
   NOBS & CO — Cart drawer
   Abre/fecha, altera quantidade, remove e adiciona sugestões.
   Após cada mudança, re-renderiza a section pelo servidor
   (Section Rendering API) — então barra de frete, subtotal e
   contagem se atualizam sozinhos, sem cálculo no JS.
   ============================================================ */
(function () {
  'use strict';

  var SECTION = 'nobs-cart-drawer';
  var root, panel;

  function el() {
    root = document.querySelector('[data-nobs-cd]');
    panel = root ? root.querySelector('.nobs-cd__panel') : null;
    return !!root;
  }

  /* Sections dentro de grupo têm ID qualificado (sections--123__nobs-cart-drawer);
     o data-section-id do Liquid traz o ID certo pra Section Rendering API. */
  function sectionId() {
    return (root && root.dataset.sectionId) || SECTION;
  }

  /* ---------- abrir / fechar ---------- */
  function open() {
    if (!root && !el()) return;
    root.hidden = false;
    void root.offsetWidth; // força reflow pra transição rodar
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (root) root.hidden = true; }, 320);
  }

  function busy(on) {
    if (root) root.classList.toggle('is-busy', !!on);
  }

  /* ---------- re-render pelo servidor ---------- */
  function refresh() {
    if (!root) return Promise.resolve();
    var sid = sectionId();
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[sid];
        if (!html) return;
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var freshPanel = tpl.querySelector('.nobs-cd__panel');
        if (freshPanel && panel) panel.innerHTML = freshPanel.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- bolha do carrinho no header (só o contador) ---------- */
  function refreshBubble() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var target = document.getElementById('cart-icon-bubble');
        if (!target) return;
        var bubble = target.querySelector('.cart-count-bubble');
        if (c.item_count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            target.appendChild(bubble);
          }
          bubble.innerHTML = '<span aria-hidden="true">' + (c.item_count < 100 ? c.item_count : '99') + '</span>';
        } else if (bubble) {
          bubble.parentNode.removeChild(bubble);
        }
      })
      .catch(function () {});
  }

  function afterChange() {
    // atualiza também as barras de frete que ficam NA PÁGINA (home "Monte seu
    // kit", PDP "Complete seu ritual") — assim elas sobem ao adicionar e
    // DIMINUEM ao remover, sem recarregar.
    if (window.NobsBars && typeof window.NobsBars.refresh === 'function') {
      window.NobsBars.refresh();
    }
    return Promise.all([refresh(), refreshBubble()]).then(function () { busy(false); });
  }

  /* ---------- mutações do carrinho ---------- */
  function changeLine(line, quantity) {
    busy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(afterChange)
      .catch(function () { busy(false); });
  }

  function addItems(items) {
    busy(true);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(afterChange)
      .catch(function () { busy(false); });
  }

  /* ---------- delegação de eventos (sobrevive ao re-render) ---------- */
  function bind() {
    if (!el()) return;

    root.addEventListener('click', function (e) {
      // fechar
      if (e.target.closest('[data-nobs-cd-close]')) {
        e.preventDefault();
        close();
        return;
      }

      // remover item
      var removeBtn = e.target.closest('[data-nobs-cd-remove]');
      if (removeBtn) {
        e.preventDefault();
        changeLine(removeBtn.getAttribute('data-nobs-cd-remove'), 0);
        return;
      }

      // quantidade
      var qtyBtn = e.target.closest('[data-nobs-cd-qty]');
      if (qtyBtn && !qtyBtn.disabled) {
        e.preventDefault();
        var to = parseInt(qtyBtn.dataset.to, 10);
        if (to >= 0) changeLine(qtyBtn.getAttribute('data-nobs-cd-qty'), to);
        return;
      }

      // clicar no nome/imagem da sugestão abre o produto (não adiciona)
      if (e.target.closest('.nobs-cd__up a')) return;

      // clicar na sugestão ADICIONA na hora (1 clique, sem confirmar)
      var up = e.target.closest('[data-nobs-cd-up]');
      if (up && !up.classList.contains('is-adding')) {
        e.preventDefault();
        var vid = parseInt(up.dataset.variantId, 10);
        if (vid) {
          up.classList.add('is-adding');
          addItems([{ id: vid, quantity: 1 }]);
        }
        return;
      }
    });

    // Esc fecha
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root && !root.hidden) close();
    });

    // ícone de carrinho no header abre o drawer
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('#cart-icon-bubble, [data-nobs-cart-open]');
      if (!trigger) return;
      e.preventDefault();
      open();
      refresh();
    });
  }

  /* ---------- API pública (usada pela PDP e pela home) ---------- */
  window.NobsCart = {
    open: function () { open(); },
    close: close,
    refresh: refresh,
    /* abre já com o conteúdo atualizado */
    openRefreshed: function () {
      open();
      return afterChange();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
